export function getMaterials(limit = 7, page = 0) {
    return new Promise((resolve, reject) => {
        fetch(`https://russian.rt.com/listing/type.Article.tag.olimpiiskie-igry/prepare/json/${limit}/${page}`, {
            method: 'GET',
            mode: 'cors',
            credentials: 'omit'
        }).then(res => res.json(res)
        ).then(json => resolve(json)
        ).catch(err => reject(err));
    });
}

export function getNews(limit = 10, page = 0) {
    return new Promise((resolve, reject) => {
        fetch(`https://russian.rt.com/listing/type.News.tag.olimpiiskie-igry/prepare/json/${limit}/${page}`, {
            method: 'GET',
            mode: 'cors',
            credentials: 'omit'
        }).then(res => res.json(res)
        ).then(json => resolve(json)
        ).catch(err => reject(err));
    });
}




// WEBPACK FOOTER //
// ./src/api/materials.js